import React, { useEffect, useState } from "react";
import * as Library from "../utils/Library";
const AppContext = React.createContext();

export const AppProvider = ({ children }) => {
    /* #region Main App */
    const [appPasswordActive, setAppPasswordActive] = useState(checkPasswordActive()); // Checks if needs app password
    const [appPasswordValidated, setAppPasswordValidated] = useState(false); // Starting app with password validation
    const [isLoadingApp, setIsLoadingApp] = useState(false); // Handles the loading state of the app
    /* #endregion */

    // BOImage States
    const [boImageIsLoading, setBOImageIsLoading] = useState(false); // Botag is loading data
    const [selectedBOImageData, setSelectedBOImageData] = useState(null); // Selected BOImage data

    // BOTag States
    const [BOTagsList, setBOTagsList] = useState([]); // List of botags
    const [availableStoresLoader, setAvailableStoresLoader] = useState(false); // Botag algorithmn is loading data
    const [selectedBotag, setSelectedBotag] = useState(null); // Selected botag
    const [selectedBotagStoreDetails, setSelectedBotagStoreDetails] = useState(null); // Selected botag store details
    const [selectedBrandID, setSelectedBrandID] = useState("");
    const [primaryImageData, setPrimaryImageData] = useState("");
    const [selectedHomePageBotagId, setSelectedHomePageBotagId] = useState("");
    const [storeSearchLoading, setStoreSearchLoading] = useState(false);
    const [shopperBagItem, setShopperBagItem] = useState([]); // Shopper bag item data
    const [shopperBagID, setShopperBagID] = useState(null);
    const [botagToPurchaseData, setBotagToPurchaseData] = useState({
        GTINbarcode: undefined,
        brandInfo: {
            _id: undefined,
            name: undefined
        },
        productInfo: {
            _id: undefined,
            name: undefined,
            productType: undefined
        },
        selectedSize: undefined,
        selectedColor: undefined,
        selectedQuantity: undefined,
        deliveryPreference: undefined,
        deliveryData: {
            cf: undefined, //if courier or shipping, returns the courier or shipping model, if pickup returns "yes"
            distanceTime: undefined,
            distanceTimeText: undefined,
            distanceToStore: undefined,
            distanceToStoreText: undefined,
            googleMapsStatus: undefined,
            pickUpFormula: undefined, //INT
            courierFormula: undefined, //INT
            shippingFormula: undefined, //INT
            price: undefined,
            stock: undefined,
            type: undefined, // pickup, courier, shipping
            _id: undefined, //not used
            deliveryCharges: undefined,
            fastestOption: undefined,
            cheapestOption: undefined,
            estimatedTime: undefined, //only on courier and shipping
            storeDetails: {
                _id: undefined,
                ourID: undefined,
                name: undefined
            } // Store Details includes all store info on database
        }
    });
    const [productColorImageURL, setProductColorImageURL] = useState(null); // Product image URL based on selected color

    /* #region AI CHAT SIDE PANEL */
    const [aiChatLoading, setAiChatLoading] = useState(false); // Handles the loading state of the AI chat inside the chat window
    const [aiChatIsVisible, setAiChatIsVisible] = useState(true);
    const [aiChatIsDisabled, setAiChatIsDisabled] = useState(false);
    // ---- AI Chat Window and Side Panel States ----
    const [aiChatWindowOpen, setAiChatWindowOpen] = useState(true); // We no longer use chat window, only side panel
    const [aiChatSidePanelOpen, setAiChatSidePanelOpen] = useState(false);
    // ---- AI Chats conversation states ----
    const [showChatConversation, setShowChatConversation] = useState(true);
    const [showChatAllPanel, setShowChatAllPanel] = useState(false);
    const [showChatArchived, setShowChatArchived] = useState(false);
    // ---- AI Chat Messages ----
    const [aiChatMessages, setAiChatMessages] = useState([]);
    const [aiActiveChats, setAiActiveChats] = useState([]);
    const [aiArchivedChats, setAiArchivedChats] = useState([]);
    const [aiChatCurrentThreadID, setAiChatCurrentThreadID] = useState(null);
    // ---- File Upload State ----
    const [fileUpload, setFileUpload] = useState({ file: null, fileName: null });
    const [aiChatFetchingReply, setAiChatFetchingReply] = useState(false);
    const [replaceCurrentBotMessage, setReplaceCurrentBotMessage] = useState(null);
    // ---- AI TOOLS ----
    const [aiSelectedNewSize, setAiSelectedNewSize] = useState(null);
    const [aiSelectedNewColor, setAiSelectedNewColor] = useState(null);
    const [aiSelectedNewDeliveryMethod, setAiSelectedNewDeliveryMethod] = useState(null);
    const [aiOpenBOtag, setAiOpenBOtag] = useState(false);
    /* #endregion */

    /* #region Methods */
    function checkPasswordActive() {
        return parseInt(process.env.REACT_APP_SHOW_PASSWORD_SCREEN) !== 0;
    }
    /* #endregion */

    //#region EFFECT
    useEffect(() => {
        if (localStorage.getItem("pid")) {
            Library.makePostRequest("getShopperBagsData", { BOthebotAccountID: localStorage.getItem("pid") })
                .then(res => {
                    const { data } = res;
                    const shopperBags = data.data; // Array of bags
                    shopperBags.forEach(bag => {
                        setShopperBagID(bag._id);
                        setShopperBagItem(bag.items);
                    });
                })
                .catch(error => {
                    console.error("Error fetching shopper bags data:", error);
                });
        } else {
            const shopperLocalBag = localStorage.getItem("shopperBag");
            if (shopperLocalBag) {
                // Parse existing shopperBag and append new items
                const existingBag = JSON.parse(shopperLocalBag);
                setShopperBagItem(existingBag.shopperBag.items);
            }
        }
    }, []);
    //#endregion EFFECT

    return (
        <AppContext.Provider
            value={{
                appPasswordActive,
                setAppPasswordActive,
                appPasswordValidated,
                setAppPasswordValidated,
                isLoadingApp,
                setIsLoadingApp,

                selectedBOImageData,
                setSelectedBOImageData,

                BOTagsList,
                setBOTagsList,
                boImageIsLoading,
                setBOImageIsLoading,
                availableStoresLoader,
                setAvailableStoresLoader,
                selectedBotag,
                setSelectedBotag,
                selectedBotagStoreDetails,
                setSelectedBotagStoreDetails,
                selectedBrandID,
                setSelectedBrandID,
                primaryImageData,
                setPrimaryImageData,
                selectedHomePageBotagId,
                setSelectedHomePageBotagId,
                storeSearchLoading,
                setStoreSearchLoading,
                shopperBagItem,
                setShopperBagItem,
                shopperBagID,
                setShopperBagID,
                botagToPurchaseData,
                setBotagToPurchaseData,
                productColorImageURL,
                setProductColorImageURL,

                aiChatLoading,
                setAiChatLoading,
                aiChatIsVisible,
                setAiChatIsVisible,
                aiChatIsDisabled,
                setAiChatIsDisabled,
                aiChatWindowOpen,
                setAiChatWindowOpen,
                aiChatSidePanelOpen,
                setAiChatSidePanelOpen,
                showChatConversation,
                setShowChatConversation,
                showChatAllPanel,
                setShowChatAllPanel,
                showChatArchived,
                setShowChatArchived,
                aiChatMessages,
                setAiChatMessages,
                aiActiveChats,
                setAiActiveChats,
                aiArchivedChats,
                setAiArchivedChats,
                aiChatCurrentThreadID,
                setAiChatCurrentThreadID,
                fileUpload,
                setFileUpload,
                aiChatFetchingReply,
                setAiChatFetchingReply,
                replaceCurrentBotMessage,
                setReplaceCurrentBotMessage,
                aiSelectedNewSize,
                setAiSelectedNewSize,
                aiSelectedNewColor,
                setAiSelectedNewColor,
                aiSelectedNewDeliveryMethod,
                setAiSelectedNewDeliveryMethod,
                aiOpenBOtag,
                setAiOpenBOtag
            }}>
            {children}
        </AppContext.Provider>
    );
};

// This function is called to reset the AI panel states
export const resetAIPanelStates = (AppContext, cleanChat = true, closeChat = false) => {
    const {
        setAiChatLoading,
        setAiChatIsVisible,
        setAiChatIsDisabled,
        setAiChatWindowOpen,
        setAiChatSidePanelOpen,
        setShowChatConversation,
        setShowChatAllPanel,
        setShowChatArchived,
        setAiChatMessages,
        setAiChatCurrentThreadID,
        setAiActiveChats,
        setAiArchivedChats,
        setFileUpload
    } = AppContext;

    if (cleanChat) {
        setAiChatLoading(false);
        setAiChatIsVisible(true);
        setAiChatIsDisabled(false);
        setShowChatConversation(true);
        setShowChatAllPanel(false);
        setShowChatArchived(false);
        setAiChatMessages([]);
        setAiChatCurrentThreadID(null);
        setAiActiveChats([]);
        setAiArchivedChats([]);
        setFileUpload({ file: null, fileName: null });
    }

    if (closeChat) {
        setAiChatWindowOpen(false);
        setAiChatSidePanelOpen(false);
    }
};

export default AppContext;
